/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseSnippetParser = /* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['key', codecString],
    ['value', codecString],
]);
export class CourseSnippet extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseSnippetParser.decode(input).map(res => new CourseSnippet(res));
    }
    static unsafeDecode(input) {
        return CourseSnippet.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseSnippetParser.encode(data);
    }
    static schema() {
        return CourseSnippetParser.schema();
    }
}
